import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const DatingAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.dating} />

export default DatingAppDevelopment
